/**
 * UpCart Upsell Variant Reorder
 * Reorders variant options from "6-3-1 Month Supply" to "1-3-6 Month Supply"
 * and sets 1-Month Supply as the default selected option
 */

(function() {
  'use strict';

  // Function to reorder variant options
  function reorderVariantOptions(select) {
    const options = Array.from(select.options);

    // Check if options exist
    if (options.length === 0) {
      return;
    }

    // Find options by their text content (looking for month supply options)
    const oneMonth = options.find(opt => opt.text.includes('1-Month Supply'));
    const threeMonth = options.find(opt => opt.text.includes('3-Month Supply'));
    const sixMonth = options.find(opt => opt.text.includes('6-Month Supply'));

    // If we found all three month options, check if they need reordering
    if (oneMonth && threeMonth && sixMonth) {
      // Check current order
      const oneIndex = options.indexOf(oneMonth);
      const threeIndex = options.indexOf(threeMonth);
      const sixIndex = options.indexOf(sixMonth);

      // Check if already in correct order (1-3-6)
      const isCorrectOrder = oneIndex < threeIndex && threeIndex < sixIndex;

      if (!isCorrectOrder) {
        // Create array to hold reordered options
        const reorderedOptions = [];

        // New order: 1-month, 3-month, 6-month
        reorderedOptions.push(oneMonth);
        reorderedOptions.push(threeMonth);
        reorderedOptions.push(sixMonth);

        // Clear existing options
        select.innerHTML = '';

        // Add reordered options
        reorderedOptions.forEach(option => {
          select.appendChild(option);
        });

        console.log('UpCart variant options reordered: 1-3-6 month');
      }

      // Always set 1-month as selected if it's not already
      if (!oneMonth.selected) {
        oneMonth.selected = true;
        select.selectedIndex = 0; // Explicitly set the selected index to first option

        // Trigger change event to notify UpCart of the selection change
        const changeEvent = new Event('change', { bubbles: true });
        select.dispatchEvent(changeEvent);

        console.log('Set 1-month as selected and triggered change event');
      }

      // Mark as reordered to prevent duplicate processing
      select.dataset.reordered = 'true';
    }
  }

  // Function to process all upsell variant selectors
  function processUpsellSelectors() {
    // Get all selectors, including those in shadow DOM
    const upCartElement = document.getElementById('upCart');
    let selectors = [];

    if (upCartElement && upCartElement.shadowRoot) {
      selectors = upCartElement.shadowRoot.querySelectorAll('.upcart-upsell-item-variant-selector');
    }

    selectors.forEach(select => {
      // Process each selector, removing the data-reordered flag first
      // to allow reprocessing in case UpCart cloned it
      if (select.dataset.reordered === 'true') {
        select.dataset.reordered = 'false';
      }
      reorderVariantOptions(select);
    });
  }

  // Function to observe shadow DOM changes (UpCart uses shadow DOM)
  function observeUpCart() {
    const upCartElement = document.getElementById('upCart');

    if (!upCartElement) {
      return;
    }

    // Try to access shadow root
    const shadowRoot = upCartElement.shadowRoot;

    if (shadowRoot) {
      // Process any existing selectors
      processUpsellSelectors();

      // Create observer for shadow DOM changes
      const observer = new MutationObserver((mutations) => {
        processUpsellSelectors();
      });

      // Start observing the shadow root
      observer.observe(shadowRoot, {
        childList: true,
        subtree: true
      });

      console.log('UpCart variant reorder observer initialized');
    }
  }

  // Function to find selectors in shadow DOM
  function findSelectorsInShadowDOM() {
    const upCartElement = document.getElementById('upCart');

    if (upCartElement && upCartElement.shadowRoot) {
      const shadowRoot = upCartElement.shadowRoot;
      const selectors = shadowRoot.querySelectorAll('.upcart-upsell-item-variant-selector');

      selectors.forEach(select => {
        reorderVariantOptions(select);
      });
    }
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Initial check
    observeUpCart();
    findSelectorsInShadowDOM();

    // Set up observer for when UpCart element is added to DOM
    const bodyObserver = new MutationObserver((mutations) => {
      const upCartElement = document.getElementById('upCart');
      if (upCartElement) {
        observeUpCart();
        findSelectorsInShadowDOM();
      }
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also check periodically for the first few seconds (fallback)
    let checkCount = 0;
    const checkInterval = setInterval(() => {
      findSelectorsInShadowDOM();
      checkCount++;

      if (checkCount >= 20) { // Stop after 10 seconds (20 * 500ms)
        clearInterval(checkInterval);
      }
    }, 500);
  }

})();
